import { globalHive } from '../../src/modules/hive'
import type { Base_Bus } from '../Base/Base.Bus'
import { Base_Dispatcher } from '../Base/Base.Dispatcher'
import { Loca_SET_DOWNLOADING_LOCATIONS } from './Loca.constants'
import { Loca_getLocations } from './Loca.getLocations'
import { Logg_event } from '../Logg/Logg.event'
import { Serv_send } from '../Serv/Serv.socketClient'
import { Sync_sync } from '../Sync/Sync.initialise'
import { Util_unixTime } from '../Util/Util.date'
import Store from '../../src/stores/location'

export async function Loca_addLocationToUser(id: number, bus: Base_Bus) {
    Logg_event('Start', { label: 'location.addLocationToUser' })

    const oldDownloadingLocations = Array.from(Store.getDownloadingLocations())
    dispatchDownloadingLocations(new Set(oldDownloadingLocations.concat(id)))

    await Serv_send('locations.addStore', { location: id })

    // Reset the last sync time so that we get the data for the location
    // that happened before our actual last sync time
    globalHive.setlastDBupdate('sync', Util_unixTime(0))
    globalHive.setlastDBupdate('timeline', Util_unixTime(0))
    await Sync_sync('Location added', bus)
    await Loca_getLocations()

    // update the list of locations currently downloading
    const newDownloadingLocations = new Set(Array.from(Store.getDownloadingLocations()))
    newDownloadingLocations.delete(id)
    dispatchDownloadingLocations(newDownloadingLocations)
}

function dispatchDownloadingLocations(downloadLocations: Set<number>) {
    Base_Dispatcher.dispatch({
        actionType: Loca_SET_DOWNLOADING_LOCATIONS,
        data: downloadLocations,
    })
}
